var render = function render(){var _vm=this,_c=_vm._self._c;return _c('create-edit-role',{attrs:{"isEdit":"","roleId":_vm.$route.params.roleId,"cancelRoute":"Role"}})
}
var staticRenderFns = []

export { render, staticRenderFns }